@if (parentForm()) {
  <div class="input-wrapper" [formGroup]="parentForm()!">
    <input
      class="input-element"
      #input
      [type]="inputType()"
      [placeholder]="placeholder()"
      [class.has-button]="buttonIcon()"
      [class.has-input-icon]="inputIcon()"
      [class.subtle-focus-input]="subtleFocus()"
      [formControlName]="name()"
      (focus)="focus.emit($event)"
      (blur)="blur.emit($event)"
      [algTooltip]="tooltipText()"
      [tooltipEvent]="tooltipEvent()"
      [tooltipPosition]="tooltipPosition()"
      [tooltipDisabled]="tooltipDisabled()"
      tooltipStyleClass="secondary"
    >
    @if (hasClearButton() && hasValue()) {
      <button
        class="icon-wrapper clear-button"
        type="button"
        (click)="clearInput(); input.focus()"
        tabindex="-1"
      >
        <i class="icon ph ph-x"></i>
      </button>
    }
    @if (inputIcon()) {
      <span class="icon-wrapper">
        <i class="icon {{ inputIcon() }}"></i>
      </span>
    }
    @if (buttonIcon()) {
      <span class="input-button" (click)="onButtonClick()">
        <i class="{{ buttonIcon() }}"></i>
      </span>
    }
  </div>
}

<alg-input-error [form]="parentForm()" [inputName]="name()"></alg-input-error>
